import * as React from 'react';
import { Dispatch, connect } from "react-redux";
import { getDentists, requestDentists } from "../../redux/actions/find-a-dentist-api";
import { setPage, updateTextFilter } from "../../redux/actions/actions";
import { FindAPDAppState } from "../../classes/redux-states";

interface ExternalProps {
    filterName: string;
    placeholderText: string;
    filterLabel: string;
}

interface DispatchToProps {
	requestDentists: (page: number) => any;
	setPage: (page: number) => any;
    updateTextFilter: (filterName: string, filterValue: string) => any;
}

type TextFilterProps = ExternalProps & DispatchToProps;

export class FilterItemTextComponent extends React.Component<TextFilterProps, any> {
    constructor(props: TextFilterProps) {
		super(props);

		this.textChangeEvent = this.textChangeEvent.bind(this);
		this.getResults = this.getResults.bind(this);
    }

    textChangeEvent(event) {
        this.props.updateTextFilter(this.props.filterName, event.target.value);
	}

	getResults(event) {
		if (event.which == '13') {
			this.props.requestDentists(1);
			this.props.setPage(1);
		}
	}

    render() {
        return (
            <div className="find-a-pd-filters-panel-item">
                <label htmlFor={this.props.filterName}>{this.props.filterLabel}</label>
				<input className="textFilter" type="text" name={this.props.filterName} placeholder={this.props.placeholderText} onKeyPress={this.getResults}onChange={this.textChangeEvent} />
            </div>
        );
    }
}

function mapDispatchToProps(dispatch: Dispatch<FindAPDAppState>): DispatchToProps {
	return {
		requestDentists: (page: number) => dispatch(getDentists(page)),
		setPage: (page: number) => dispatch(setPage(page)),
        updateTextFilter: (filterName: string, filterValue: string) => dispatch(updateTextFilter(filterName, filterValue))
    }
}

var temp = connect(null, mapDispatchToProps)(FilterItemTextComponent);

export default connect<null, DispatchToProps, ExternalProps>(null, mapDispatchToProps)(FilterItemTextComponent);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/findapd/components/filters/filter-item-text.tsx